import Button from 'react-bootstrap/esm/Button'
import Form from 'react-bootstrap/Form'
import React, {useEffect, useState} from 'react'
import {USERSIGNIN} from '../../../../api'
import {createNewHeaders, executePost} from '../../../../configs/Kubuku'
import {useNavigate} from 'react-router-dom'
import {v4 as uuidv4} from 'uuid'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Alert} from 'react-bootstrap'

export function Login() {
  const [email, setEmail] = useState('')
  const [new_password, setPassword] = useState('')
  const [uuid] = useState(uuidv4())
  const [notification, setNotification] = useState(null)
  const [loading, setLoading] = useState(false)
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const {saveAuth, setCurrentUser} = useAuth()
  const [kombinasi, setKombinasi] = useState('')

  // console.log(uuid)
  // const navigate = useNavigate()

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const sign = require('jwt-encode');
      const secretKey = 'At98rMtq6PndWiNoMQhKcDvbPigQiBuz';
      const data = {
        APPID: 12,
        UUID: uuid,
      };
  
      const token = sign(data, secretKey);
      createNewHeaders(token);
      localStorage.setItem('UUID', uuid);
  
      try {
        const formData = new FormData();
        formData.append('username', email);
        formData.append('new_password', new_password);
  
        const json = await executePost(USERSIGNIN, formData);
        if (json.code === 200) {
          saveAuth(json.data);
          setCurrentUser(json.data);
          localStorage.setItem('token', json.data.token);
          localStorage.setItem('UID', json.data.user.id);
          localStorage.setItem('username', json.data.user.username);
          localStorage.setItem('logo', json.data.user.logo);
          localStorage.getItem('UUID');
        } else {
          saveAuth(undefined);
          setNotification(json.msg);
          setEmailError(json.data.email);
          setPasswordError(json.data.password);
        }
      } catch (error) {
        saveAuth(undefined);
        console.error(error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <div className='d-flex flex-column justify-content-center align-items-center my-5 my-md-15'>
        <div className='w-100 w-lg-500px p-10'>
          <Form onSubmit={handleLogin} className='form' id='kt_sign_in_form' action='#'>
            <div className='text-center mb-11'>
              <img
                className='h-100px img-fluid'
                src={toAbsoluteUrl('/media/logos/logo-literasi-satu-pintu-fix-color.png')}
                alt='metronic'
              />
            </div>
            {notification && (
              <div className='alert alert-danger' role='alert'>
                {notification}
              </div>
            )}
            <div className='mb-3'>
              <Form.Control
                onChange={(e) => setEmail(e.target.value)}
                type='text'
                placeholder='Email'
                name='email'
                className='form-control bg-transparent'
              />
              <Form.Text className='text-danger'>{emailError}</Form.Text>
            </div>
            <div className='mb-3'>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                type='password'
                placeholder='Password'
                name='password'
                className='form-control bg-transparent'
              />
              <Form.Text className='text-danger'>{passwordError}</Form.Text>
            </div>
            {kombinasi && <Alert variant='danger'>{kombinasi}</Alert>}
            <div className='d-grid mb-5'>
              <Button className='btn btn-success' type='submit'>
                <span className='indicator-label'>Login</span>
                {loading && (
                  <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  )
}
